import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { ReportsPermissionResolver } from '../reports/reports-permission.resolver';
import { ClosingReportResolver } from './closing-report/resolvers/closing-report.resolver';
import { AllowIrsReportingResolver } from './allow-irs-reporting.resolver';

export class ReportsRouteDefinition {
  public static getRoutes(
    showClosingReports: boolean,
    showIrsReports: boolean,
    isBlackboxV2: boolean
  ): RouteDefinition {
    const menuItems: RouteDefinition = {
      path: RoutePaths.REPORTS,
      title: 'Reports',
      icon: 'icon-reports.svg',
      position: 2,
      resolver: ReportsPermissionResolver,
      children: [
        {
          path: RoutePaths.RECEIPTS,
          parentPath: RoutePaths.REPORTS,
          title: 'Receipts',
          position: 1
        },
        {
          path: RoutePaths.LABOUR,
          parentPath: RoutePaths.REPORTS,
          title: 'Labour Reports',
          position: 2
        },
        {
          path: RoutePaths.HOUR,
          parentPath: RoutePaths.REPORTS,
          title: 'Hour Reports',
          position: 3
        },
        {
          path: RoutePaths.DAY,
          parentPath: RoutePaths.REPORTS,
          title: 'Day Reports',
          position: 4
        },
        {
          path: RoutePaths.WEEK,
          title: 'Week Reports',
          position: 5,
          parentPath: RoutePaths.REPORTS
        },
        {
          path: RoutePaths.MONTH,
          parentPath: RoutePaths.REPORTS,
          title: 'Month Reports',
          position: 6
        },

        {
          path: RoutePaths.PRODUCT,
          parentPath: RoutePaths.REPORTS,
          title: 'Product Reports',
          position: 8
        },
        {
          path: RoutePaths.CATEGORY,
          parentPath: RoutePaths.REPORTS,
          title: 'Category Reports',
          position: 9
        },
        {
          path: RoutePaths.USER,
          parentPath: RoutePaths.REPORTS,
          title: 'User Reports',
          position: 10
        },
        {
          path: RoutePaths.REVENUE,
          parentPath: RoutePaths.REPORTS,
          title: 'Revenue Reports',
          position: 11
        },
        {
          path: RoutePaths.INGREDIENT,
          parentPath: RoutePaths.REPORTS,
          title: 'Ingredient Reports',
          position: 12
        },
        {
          path: RoutePaths.SHIFT,
          parentPath: RoutePaths.REPORTS,
          title: 'Shift Reports',
          position: 13
        },
        {
          path: RoutePaths.SUMMARY,
          parentPath: RoutePaths.REPORTS,
          title: 'Summary Reports',
          position: 14
        },
        {
          path: RoutePaths.ADVANCED,
          parentPath: RoutePaths.REPORTS,
          title: 'Advanced Reports',
          position: 15
        },
        {
          path: RoutePaths.EXPORT_DATA,
          parentPath: RoutePaths.REPORTS,
          title: 'Export data',
          position: 18
        }
      ]
    };
    if (showClosingReports) {
      menuItems.children.push({
        path: RoutePaths.CLOSING,
        parentPath: RoutePaths.REPORTS,
        title: 'Closing Reports (Z)',
        position: 7,
        resolver: ClosingReportResolver
      });
    }
    if (showIrsReports) {
      menuItems.children.push({
        path: RoutePaths.IRS,
        parentPath: RoutePaths.REPORTS,
        title: 'IRS Reports',
        position: 14,
        resolver: AllowIrsReportingResolver
      });
    }
    if (isBlackboxV2) {
      menuItems.children.push({
        path: RoutePaths.FISCAL_REPORTS,
        parentPath: RoutePaths.REPORTS,
        title: 'Fiscal reports',
        position: 19
      });
    }
    return menuItems;
  }
}
